import React, { useCallback, useEffect, useState } from 'react';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverCloseButton,
} from '@chakra-ui/popover';
import { Box } from '@chakra-ui/layout';
import { FormControl, FormLabel } from '@chakra-ui/form-control';
import { Checkbox } from '@chakra-ui/checkbox';
import { Button } from '@chakra-ui/button';
import { Tooltip } from '@chakra-ui/tooltip';
import { useDisclosure } from '@chakra-ui/react';
import debounce from 'debounce-promise';
import { ValueType } from 'react-select';
import api from '../../../../../services/api';
import { useAuth } from '../../../../../contexts/auth';
import AsyncSelect from '../../../../Form/AsyncSelect2';

type OptionType = { label: string; value: string };

const MenuOpm: React.FC = () => {
  const { user, updateOpm, updateVerSubunidades } = useAuth();
  const { onOpen, onClose, isOpen } = useDisclosure();
  const [opmSelecionada, setOpmSelecionada] = useState<OptionType>();

  const promiseOptionsUnidades = useCallback(
    async (inputValue: string): Promise<OptionType[] | undefined> => {
      try {
        const response = await api.get(
          `unidades?query=${inputValue}&opm_usuario=${user.opm?.uni_codigo}`,
        );

        const responseFormated = response.data.map((item: any) => {
          return {
            value: item.uni_codigo,
            label: item.uni_sigla,
          };
        });

        return responseFormated;
      } catch (error) {
        return undefined;
      }
    },
    [user],
  );
  // eslint-disable-next-line
  const delayedQuery = useCallback(
    debounce((query: string) => promiseOptionsUnidades(query), 400),
    [promiseOptionsUnidades],
  );

  useEffect(() => {
    const load = async (): Promise<void> => {
      if (opmSelecionada) {
        updateOpm({
          uni_codigo: opmSelecionada.value,
          uni_sigla: opmSelecionada.label,
        });
      }
    };

    load();
    // eslint-disable-next-line
  }, [opmSelecionada]);

  const handleSwitchSubunidade = (sub: boolean): void => {
    updateVerSubunidades(sub ? '1' : '0');
  };

  return (
    <Box className="container-popover">
      <Popover
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        placement="bottom"
        closeOnBlur
      >
        <Tooltip hasArrow label="Trocar Unidade" placement="bottom">
          <Box>
            <PopoverTrigger>
              <Button
                _hover={{ bg: '#eee' }}
                colorScheme="white"
                color="gray.500"
                fontWeight="400"
                borderRadius="0"
                h={20}
                w={{ base: '200px', sm: '80px', md: '120px' }}
              >
                {user?.currentOpm?.uni_sigla}
              </Button>
            </PopoverTrigger>
          </Box>
        </Tooltip>
        <PopoverContent p={5}>
          <PopoverCloseButton />

          <FormControl>
            <FormLabel htmlFor="unidade">Trocar Unidade</FormLabel>
            <AsyncSelect
              placeholder="Digite...  ex.: 4ªCIA/23ºBPM "
              value={opmSelecionada}
              isClearable
              loadOptions={(value: string) => delayedQuery(value.trim())}
              onChange={(option: ValueType<OptionType, any>) => {
                const optionSelected = option as OptionType;

                setOpmSelecionada(optionSelected);
              }}
            />
          </FormControl>

          <FormControl
            paddingLeft="8px"
            display="flex"
            alignItems="center"
            mt="2"
          >
            <FormLabel htmlFor="subunidades" mb="0">
              Ver Subunidades?
            </FormLabel>
            <Checkbox
              id="subunidades"
              marginRight="4px"
              isChecked={user?.verSubunidade === '1'}
              colorScheme="green"
              onChange={(e) => handleSwitchSubunidade(e.target.checked)}
            />
            Sim
          </FormControl>
        </PopoverContent>
      </Popover>
    </Box>
  );
};

export default MenuOpm;
